import { DownloadKitButtonSelectorGzDataProvider } from '../dataProvider/DownloadKitButtonSelectorGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class DownloadKitButtonSelectorDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, DownloadKitButtonSelectorGzDataProvider);
  }
}
